import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { StihlUserDTO } from 'src/app/models/stihl-user-dto';
import { StihlNotificationDTO } from 'src/app/models/stihl-notification-dto';
import { NotificationService } from 'src/app/services/notification.service';
import { StihlSearch } from 'src/app/models/search';
import { SearchService } from 'src/app/services/search.service';
import { LogType } from '../../../enums/logType';
import { TrackingService } from 'src/app/services/tracking.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { visibleContentAnimation } from '../../../animations';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  animations: [visibleContentAnimation],
})
export class HeaderComponent {


  useSSO = environment.useSSO;

  //#region VARIABLES NOTIFICACIONES
  data: StihlNotificationDTO[] = [];
  countNotification: number = 0;
  page: number = 0;
  showMore: boolean = true;
  loading: boolean = true;
  user: StihlUserDTO;
  showNotifications: boolean = false;
  //#endregion

  //#region VARIABLES BUSCADOR
  searchText: string;
  searchResult: StihlSearch = new StihlSearch();
  currentPage: number;
  pages: number[];
  itemsPerPage: number;
  noResult: boolean = false;
  disableSearch: boolean = true;
  searching: boolean = false;
  termToSearch = "";
  //#endregion

  @ViewChild('notifications', { read: TemplateRef }) notifications: TemplateRef<any>;

  constructor(private router: Router,
    private authJwtService: AuthJwtService,
    private authService: AuthService,
    private searchService: SearchService,
    private trackingService: TrackingService,
    private notificationService: NotificationService,
    private offcanvasService: NgbOffcanvas) {

    this.currentPage = 1;
    this.pages = new Array(0);
    this.itemsPerPage = 5;

    this.getCountNotification();
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.getCountNotification();
      }
    });


  }

  ngOnInit() {
    this.loadEvents();
  }

  logout() {
    this.trackUser(LogType.Logout);
    if (this.useSSO) {
      this.authService.logout();
    }
    else {
      this.authJwtService.logout();
      this.router.navigate(['/login']);
    }
  }
  trackUser(idLogType) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }

  //#region NOTIFICACIONES
  resetData() {
    this.data = [];
    this.page = 0;
    this.showMore = true;
    this.loading = true;
  }

  loadEvents() {
    const that = this;
    $('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
    });

    $('#modalSearch').on('hidden.bs.modal', function () {
      $('#searchDocument').val('');
      that.disableSearch = true;
    });
    $('#clearButton').click(function () {
      that.termToSearch = "";
      that.disableSearch = true;
    });
    $('#clearButtonModal').click(function () {
      that.termToSearch = "";
      that.disableSearch = true;
    });
  }

  getContentNotification() {
    const that = this;
    if (that.showMore == true) {
      this.notificationService.getUserAvailableNotification(that.page).subscribe(resp => {
        Array.prototype.push.apply(that.data, resp);
        that.showMore = (that.data.length != that.countNotification);
        that.loading = false;
      }, (err) => {

      });
    }
  }

  getCountNotification(show?) {
    if (show)
      this.showNotificationList();
    this.resetData();
    this.getContentNotification();
    this.notificationService.getUserNotificationCount().subscribe(resp => {
      this.countNotification = resp;
    }, (err) => {
    });
  }


  loadMore() {
    this.page++;
    this.getContentNotification();
  }

  showNotificationList() {
    if (this.countNotification > 0) {
      this.showNotifications = true;
      this.offcanvasService.open(this.notifications, { position: 'end', panelClass: 'notifications_container' });
    } else {
      this.offcanvasService.dismiss('No hay notificaciones');
    }

  }

  closeNotificationView() {

    this.showNotifications = false;
    document.getElementById('closeModalButton').click();
  }


  closeNotification(idNotification) {
    this.notificationService.updateNotificationUser(idNotification).subscribe(resp => {
      this.getCountNotification();
      this.closeNotificationView();
    });
  }

  routerLinkQueryParams(url, param, value, idNotification) {
    this.router.navigate([url], { queryParams: { [param]: value } });
    this.closeNotification(idNotification);
  }

  //#endregion

  //#region BUSCADOR

  setDisableSearch() {
    if (this.termToSearch != null && this.termToSearch != '')
      this.disableSearch = false;
    else
      this.disableSearch = true
  }


  onEnterPress() {
    document.getElementById("btnSearch").click()
  }


  searchContent() {

    if (this.termToSearch != null && this.termToSearch != '') {
      this.termToSearch = this.termToSearch.replace("/", " ");
      // Reset search data
      this.searchResult = new StihlSearch();
      this.currentPage = 0;
      this.pages = new Array(0);

      // Ketp new search term
      this.searchText = this.termToSearch;

      this.loading = true;
      this.searching = true;
      this.noResult = false;

      // Search
      this.searchService.searchTerm(this.searchText, 1, this.itemsPerPage).subscribe((searchModel) => {
        this.loading = false;
        this.searching = false;
        // Kept search result
        this.searchResult = searchModel;

        // Check results
        if (this.searchResult.items.length == 0) {
          this.noResult = true;
        }
        // Update paging data
        this.currentPage = 0;
        this.pages = new Array(Math.ceil(this.searchResult.total_item / this.itemsPerPage));
      });
    }
  }

  pagingSearch(nextPage) {
    if (nextPage >= 0 && nextPage < this.pages.length) {
      console.log(nextPage + ' | ' + this.pages.length);
      // Reset search data
      this.searchResult = new StihlSearch();

      this.loading = true;
      this.searching = true;
      this.noResult = false;

      this.searchService.searchTerm(this.searchText, (nextPage * this.itemsPerPage) + 1, this.itemsPerPage).subscribe((searchModel) => {
        this.loading = false;
        this.searching = false;
        // Kept search result
        this.searchResult = searchModel;

        // Check results
        if (this.searchResult.items.length == 0) {
          this.noResult = true;
        }

        // Update paging data
        this.currentPage = nextPage;
        this.pages = new Array(Math.ceil(this.searchResult.total_item / this.itemsPerPage));
      });
    }
    return false;

  }


  goToSection(section) {
    document.getElementById("closeModalButton").click();
    this.termToSearch = "";
    this.disableSearch = true;
    this.router.navigate([section]);
  }

  trackDocument(type, idDocument) {
    if (type == "DOCUMENTO") {
      this.trackingService
        .trackDocument(idDocument, LogType.Download)
        .subscribe();
    }

  }
  //#endregion

}
